import { Component, OnInit, ViewChild, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { ImageCroppedEvent, ImageCropperComponent, base64ToFile, ImageTransform } from 'ngx-image-cropper';
import { environment } from 'src/environments/environment';
import { ToastrMessageServiceService } from '../../services/toastr-message/toastr-message-service.service';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-image-cropper-popup',
  templateUrl: './image-cropper-popup.component.html',
  styleUrls: ['./image-cropper-popup.component.scss']
})
export class ImageCropperPopupComponent implements OnInit, OnChanges {

  @Input() roundCropper = false;

  @Input() isVisible = true;
  @Input() image: File;
  @Output() submitImage: EventEmitter<string> = new EventEmitter();
  @Output() cancelEvent: EventEmitter<void> = new EventEmitter();

  @ViewChild(ImageCropperComponent) imageCropper: ImageCropperComponent;

  maxFileSizeInMegabytes = 4;
  croppedImage: string;
  croppedImageSizeInMegabytes = 0;
  isLoading = false;
  aspectRatio: number;
  resultImageType: string;
  byteToMbConversionRate: number = 1024 * 1024;
  transform: ImageTransform = {};
  rotationDegree = 0;
  loadImageFailMsg: string = _('image-cropper-popup.toastr-messages.load-image-fail-message');

  constructor(private toastrMessageServiceService: ToastrMessageServiceService, private translate: TranslateService) {
    this.maxFileSizeInMegabytes = environment.maxImageSize;
  }

  ngOnInit() {
    this.setAspectRatio();
    this.setImageType(this.image);

    if (!HTMLCanvasElement.prototype.toBlob) {
      Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
        value(callback, type, quality) {
          const dataURL = this.toDataURL(type, quality).split(',')[1];
          setTimeout(() => {

            const binStr = atob(dataURL);
            const len = binStr.length;
            const arr = new Uint8Array(len);

            for (let i = 0; i < len; i++) {
              arr[i] = binStr.charCodeAt(i);
            }

            callback(new Blob([arr], { type: type || 'image/png' }));

          });
        }
      });
    }
  }

  ngOnChanges() {
    this.setAspectRatio();
    this.setImageType(this.image);
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.croppedImageSizeInMegabytes = base64ToFile(this.croppedImage).size / this.byteToMbConversionRate;
  }

  imageLoaded() {
    this.isLoading = false;
  }

  cropperReady() {
    this.isLoading = false;
  }

  loadImageFailed() {
    this.toastrMessageServiceService.error(this.loadImageFailMsg);
  }

  rotateLeft() {
    //this.isLoading = true;
    this.rotationDegree = this.rotationDegree - 90;
    this.transform = {
      ...this.transform,
      rotate: this.rotationDegree
    };
  }

  rotateRight() {
    //this.isLoading = true;
    this.rotationDegree = this.rotationDegree + 90;
    this.transform = {
      ...this.transform,
      rotate: this.rotationDegree
    };
  }

  flipHorizontal() {
    //this.isLoading = true;
    this.transform = {
      ...this.transform,
      flipH: !this.transform.flipH
    };
  }

  flipVertical() {
    //this.isLoading = true;
    this.transform = {
      ...this.transform,
      flipV: !this.transform.flipV
    };
  }

  save() {
    if (base64ToFile(this.croppedImage).size > this.maxFileSizeInMegabytes * this.byteToMbConversionRate) {
      this.toastrMessageServiceService.warningNoTranslate(this.translate
        .instant(_('image-cropper-popup.toastr-messages.exceed-size-message')) + ' '
        + this.maxFileSizeInMegabytes + this.translate.instant('image-cropper-popup.image-size-unit'));
      return;
    }

    this.complete(this.croppedImage
      //this.blobToFile(this.croppedImage, this.image.name, this.image.lastModified)
    );
  }

  cancel() {
    this.transform = {};
    this.cancelEvent.emit();
  }

  complete(emitValue: string) {
    this.submitImage.emit(emitValue);
  }

  private setAspectRatio() {
    this.aspectRatio = this.roundCropper ? 1 : 2 / 1;
  }

  private setImageType(file: File) {
    this.resultImageType = file && file.type.match(/image\/jpg|image\/jpeg/) ? 'jpeg' : 'png';
  }

  private blobToFile(theBlob: Blob, fileName: string, lastModified: number): File {
    const b: any = theBlob;
    b.lastModifiedDate = new Date();
    b.name = fileName;
    const file: File = b as File;

    return file;
  }
}
